<template>
  <div v-if="hasStaticMedia && !isMediaHidden" class="static-data-container">
    <img alt="static-image" class="static-image d-none d-lg-inline-block static_image_width" v-if="session.step_static_data.image"
         :src="session.step_static_data.image.file" />
    <img alt="static-image-tablet" class="static-image-tablet d-none d-lg-none d-md-inline-block static_image_width" v-if="session.step_static_data.image_tablet"
         :src="session.step_static_data.image_tablet.file" />
    <img alt="static-image-mobile" class="static-image-mobile d-md-none d-sm-inline-block static_image_width" v-if="session.step_static_data.image_mobile"
         :src="session.step_static_data.image_mobile.file" />

    <iframe v-if="session.step_static_data.embed_code"
            frameborder="0" allowfullscreen
            :src="session.step_static_data.embed_code"
    ></iframe>
  </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'StepMedia',
  props: {
    session: Object
  },
  computed: {
    ...mapState(['isMediaHidden']),
    hasStaticMedia: function() {
      return this.session && this.session.step_static_data && (this.session.step_static_data.image || this.session.step_static_data.embed_code)
    }
  }
}
</script>

<style scoped>
</style>
